import { render } from "./TicketsDone.vue?vue&type=template&id=92f4bd5a&scoped=true&ts=true"
import script from "./TicketsDone.vue?vue&type=script&lang=ts"
export * from "./TicketsDone.vue?vue&type=script&lang=ts"

import "./TicketsDone.vue?vue&type=style&index=0&id=92f4bd5a&scoped=true&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92f4bd5a"]])

export default __exports__